import config from 'config-base';
import { memo } from 'react';
import Image from '@base/components/src/Image';
import Link from '@base/components/src/Link';
import { Underline } from '@base/components/src/Link/types';

import styles from './Footer.module.css';
import { FooterProps } from './types';

const Footer = ({ layoutType }: FooterProps) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.logo}>
          <Image
            src="/marketplace-static/images/secure-shopping.png"
            width={143}
            height={33}
            alt="Secure Shopping 256 bit encryption"
          />
        </div>
        <div className={styles.info}>
          Please Note: You must be 18 years of age or older to order and conform to all laws governing the use and
          ownership of airguns in your local area.{' '}
          <Link data-testid={'footer-safety-link'} href={`${config.mainPyramydairUrl}/safety.html`} showCursorPointer underline={Underline.always}>
            More Info
          </Link>
        </div>
        <div className={styles.copyright}>
          © {new Date().getFullYear()} Airgun Depot. All rights reserved.
          <Link data-testid={'footer-terms-link'} href={`${config.mainPyramydairUrl}/terms.html`} showCursorPointer>
            Terms of Use
          </Link>
          &nbsp;
          <Link data-testid={'footer-privacy-policy-link'} href={`${config.mainPyramydairUrl}/privacypolicy.html`} showCursorPointer>
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default memo(Footer);
